'use client';

import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

const Checkbox = React.forwardRef(function Checkbox(
	{ checked, className, checkClassName, disabled, onChange, onCheckedChange, ...props },
	ref,
) {
	const handleCheckedChange = (nextChecked) => {
		onCheckedChange?.(nextChecked);
		if (onChange) {
			onChange({
				target: {
					checked: Boolean(nextChecked),
					value: props.value,
					id: props.id,
					name: props.name,
				},
			});
		}
	};

	return (
		<div className={cn('inline-flex items-center', className)}>
			<CheckboxPrimitive.Root
				ref={ref}
				data-slot="checkbox"
				className={cn(
					`${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} peer h-5 w-5 transition-all appearance-none rounded hover:shadow-md border border-input data-[state=checked]:bg-primary bg-card relative`,
					checkClassName,
				)}
				checked={Boolean(checked)}
				disabled={disabled}
				onCheckedChange={handleCheckedChange}
				{...props}
			>
				<CheckboxPrimitive.Indicator
					data-slot="checkbox-indicator"
					className="absolute inset-0 flex items-center justify-center p-1 text-primary-foreground"
				>
					<CheckIcon className="h-3.5 w-3.5" />
				</CheckboxPrimitive.Indicator>
			</CheckboxPrimitive.Root>
		</div>
	);
});

export { Checkbox };
